function Loading() {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">
      <div className="w-36 h-36 border-8 border-solid border-t-blue-500 rounded-full animate-spin" />
    </div>
  );
}

export default Loading;
